__turbopack_context__.v({
  "buyNow": "UIDDsG_buyNow",
  "close": "UIDDsG_close",
  "description": "UIDDsG_description",
  "dialog": "UIDDsG_dialog",
  "finePrint": "UIDDsG_finePrint",
  "header": "UIDDsG_header",
  "overlay": "UIDDsG_overlay",
  "retailerLink": "UIDDsG_retailerLink",
  "retailerLogo": "UIDDsG_retailerLogo",
  "retailerLogoCostco": "UIDDsG_retailerLogoCostco",
  "retailers": "UIDDsG_retailers",
  "title": "UIDDsG_title",
});
